import React from 'react';

function TeamHero() {
  return (
    <section className="team-hero" style={{ backgroundImage: "url('/assets/images/team-bg.jpg')" }}>
      {/* Dark overlay matching the image color scheme */}
      <div className="team-hero-overlay"></div>

      {/* Team Hero Content */}
      <div className="container team-hero-container">
        <div className="team-hero-content">
          <h1 className="team-hero-title">
            Meet the Exceptional Team Behind Your Success
          </h1>
          <p className="team-hero-description">
            Our professional experts have years of experience in BPO, IT services, digital marketing, and web development that deliver outstanding results for your business. Every team member ensures that your projects exceed expectations and maintain the highest quality with innovation.
          </p>
        </div>
      </div>
    </section>
  );
}

export default TeamHero;
